import { render, staticRenderFns } from "./ClickAndBuyColorForm.vue?vue&type=template&id=1c3ca7a2&scoped=true"
import script from "./ClickAndBuyColorForm.vue?vue&type=script&lang=js"
export * from "./ClickAndBuyColorForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3ca7a2",
  null
  
)

export default component.exports